import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth-service.service';
import { UserService } from '../services/user-service.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const canActivate = !!this.authService.getAccessToken();
    if (!canActivate) {
      // remembering the url when unauthorized user tried to access something then navigate him to his url after login.
      this.authService.setRouteBeforeGuard(state.url);
      this.router.navigate(['login']);
      return false;
    }
    // guard instead of resolver here, because we need to know user role first, but resolvers runs only after all guards has been passed
    return this.userService.getUserObservable()
      .pipe(map((user) => {
        this.userService.setUser(user);
        return canActivate;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }
}
